import Popup from './popup';

/* istanbul ignore next */
Popup.install = function (Vue) {
  Vue.component(Popup.name, Popup);
};

export default Popup;


// WEBPACK FOOTER //
// ./src/components/anyUI/popup/index.js